import { privateImageCache } from './privateImageCache';

let blobUrlsInMemory: string[] = [];

export const blobUrlStore = {

    startGarbageCollector: (selectBlobUrlsInState: () => string[]) => {
        setInterval(() => collectGarbage(selectBlobUrlsInState), 5000);
    },

    track: (blobUrl: string) => {
        blobUrlsInMemory.push(blobUrl);
    },

    dispose: (blobUrl: string) => dispose(blobUrl)
};

const collectGarbage = async (selectBlobUrlsInState: () => string[]) => {

    const blobUrlsInState = selectBlobUrlsInState();
    const privateImageBlobs = await Promise.all(Object.values(privateImageCache.loadedEntries()));

    const allBlobUrls = privateImageBlobs.concat(blobUrlsInState);

    const unusedBlobUrls = blobUrlsInMemory
        .filter(b => !allBlobUrls.includes(b));

    for (const unusedBlobUrl of unusedBlobUrls) {
        dispose(unusedBlobUrl);
    }
};

const dispose = (blobUrl: string) => {
    blobUrlsInMemory.splice(blobUrlsInMemory.indexOf(blobUrl), 1);
    window.URL.revokeObjectURL(blobUrl);
};